import * as React from "react";
import { Row, Col } from "antd";
import { TableCol, FiveSpanColLayout, FourSpanColLayout, HeaderCol, PaymentTotalHeaderCol, PaymentTotalCol, TableValueCol, HeaderTitle, PaymentRow, TotalColLayout } from "./PaymentInformation.Styled";
import { IBillOfLadingPaymentResponse, IBolCharge, IBillOfLadingReceiptDto, IVerifyFirstAtlanticPaymentResponse } from "Core/Api/Payment/Api";
import CartContext from "Context/CartContext";
import { CheckoutConfirmationHandler } from "./CheckoutConfirmationHandler";
import { CartHandler } from "components/CartManagement/CartHandler";
import ConfigUtility from "Core/ConfigUtility";

export interface Props {
    children?: React.ReactNode,
    receiptDetails?: IVerifyFirstAtlanticPaymentResponse
}

export interface State {
    charge: IBolCharge

}

export default class PaymentInformation extends React.Component<Props, State> {
    static contextType = CartContext;
    context!: React.ContextType<typeof CartContext>;
    handler: CheckoutConfirmationHandler;
    cartHandler: CartHandler;

    constructor(props: Props) {
        super(props)

        this.getCharge = this.getCharge.bind(this);
        this.state = {
            charge: {}
        }
        this.handler = new CheckoutConfirmationHandler(props);
        this.cartHandler = new CartHandler(props);
    }


    componentDidMount() {
        this.handler.CloseCart().then(x => {
            this.cartHandler.GetCart().then(y => {
                this.context.Update(y?.cart);
            });

        })
            // While this shouldn't fail, it is important not to do anything if it does
            .catch(() => { });
        this.getCharge();
    }

    getCharge() {
        if (this.props.receiptDetails?.receipt?.data) {
            this.props.receiptDetails?.receipt?.data.map(charges =>
                charges.charges?.map(chargeFound =>
                    this.setState({ charge: chargeFound })
                )
            )
        }
    }

    render() {
        const { receiptDetails } = this.props;
        //const { charge } = this.state;
        const config = ConfigUtility.getSync()!;
        return (
            <>
                <HeaderTitle>Payment Information:</HeaderTitle>
                <PaymentRow>
                    <Col span={24}>
                        <Col span={24}>
                            <TableCol {...FiveSpanColLayout}>
                                <Row>
                                    <strong><HeaderCol span={24}>Payment Method</HeaderCol></strong>
                                </Row>
                                <Row>
                                    <TableValueCol span={24}>{receiptDetails?.receipt?.paymentMethod}</TableValueCol>
                                </Row>
                            </TableCol>
                            <TableCol {...FourSpanColLayout}>
                                <Row>
                                    <strong><HeaderCol span={24}>Card | Last Digit</HeaderCol></strong>
                                </Row>
                                <Row>
                                    <TableValueCol span={24}>{receiptDetails?.receipt?.creditCardType} | {receiptDetails?.receipt?.creditCardNumberLastDigits}</TableValueCol>
                                </Row>
                            </TableCol>
                            <TableCol {...FiveSpanColLayout}>
                                <Row>
                                    <strong><HeaderCol span={24}>Authorization Code</HeaderCol></strong>
                                </Row>
                                <Row>
                                    <TableValueCol span={24}>{receiptDetails?.receipt?.authorizationCode}</TableValueCol>
                                </Row>
                            </TableCol>
                            <TableCol {...FourSpanColLayout}>
                                <Row>
                                    <strong><HeaderCol span={24}>Transaction Type</HeaderCol></strong>
                                </Row>
                                <Row>
                                    <TableValueCol span={24}>{config.TransactionType}</TableValueCol>
                                </Row>
                            </TableCol>

                            <Col
                                xs={{ span: 10, offset: 0 }}
                                sm={{ span: 10, offset: 0 }}
                                md={{ span: 6, offset: 0 }}
                                lg={{ span: 6, offset: 0 }}
                                xl={{ span: 6, offset: 0 }}>
                                <Row>
                                    <strong><HeaderCol span={24}>Billing Address</HeaderCol></strong>
                                </Row>
                                <Row>
                                    <TableValueCol span={24}>{`${receiptDetails?.receipt?.billingAddress?.addressLine1} ${receiptDetails?.receipt?.billingAddress?.addressLine2}`}</TableValueCol>
                                </Row>
                            </Col>
                        </Col>
                        <Row>
                            <PaymentTotalHeaderCol {...TotalColLayout} >
                                <strong>Total Paid (JMD)</strong>
                            </PaymentTotalHeaderCol>
                            <PaymentTotalCol {...TotalColLayout}>
                                {receiptDetails?.receipt?.paymentCurrency} ${receiptDetails?.receipt?.totalAmountPaid}
                            </PaymentTotalCol>
                        </Row>
                    </Col>
                </PaymentRow>
            </>
        )
    }
}
